import React from 'react'
import TradingTools from 'components/shared/TradingTools'
import { Row, Col } from 'antd'

export default function BrokerTradingTools({ broker }) {
  const { name, softwares } = broker
  let title = ''

  if (softwares?.data?.length > 0) {
    title = `${name} Trading Tools`

    return (
      <Row style={{ marginBottom: '16px' }}>
        <Col span={24}>
          <TradingTools title={title} softwares={softwares.data} />
        </Col>
      </Row>
    )
  }

  return null
}
